import deviceDetect from "@ntcgrgr/device-detect";

window.browser = deviceDetect.browser;
window.browserVersion = deviceDetect.version;
window.device = deviceDetect.device;
